import { navigate } from 'common-tools/ReachRouter'
import types from '../actiontypes'
import { Storage, StorageKeys } from 'common-tools/StorageHelper'
import { AddLayoutContentBreadCrumbKey } from './LayoutContentActions'
import { ShowConfirmDispatch } from './ShowNotificationActions'

export const RoutePush = (pathname, search, hash) => {
  return {
    type: types.Router.Push,
    payload: {
      pathname,
      search,
      hash
    }
  }
}

export const RoutePushDispatch = (dispatch) => {
  return (pathname, search, hash) => {
    dispatch(RoutePush(pathname, search, hash))
  }
}

export const RouteAddIndexRoute = (pathname) => {
  return {
    type: types.Router.AddIndexRoute,
    payload: pathname
  }
}

export const RouteAddIndexRouteDispatch = (dispatch) => {
  return (pathname) => {
    dispatch(RouteAddIndexRoute(pathname))
  }
}

export const sendToURL = (dispatch) => {
  return (url, breadcrumbInfo) => {
    if (breadcrumbInfo) {
      AddLayoutContentBreadCrumbKey(
        breadcrumbInfo.Key,
        breadcrumbInfo.Value,
        breadcrumbInfo.Disabled
      )
    }
    const confirmAbandon = Storage.Get(StorageKeys.ConfirmAbandonChanges)
    if (confirmAbandon) {
      ShowConfirmDispatch()(confirmAbandon, () => {
        Storage.Save(StorageKeys.ConfirmAbandonChanges, undefined)
        navigate(url)
      })
    } else {
      navigate(url)
    }
  }
}
